// extracted by mini-css-extract-plugin
export default {"container":"index_container__RkOWq","left":"index_left__HUPnl","center":"index_center__0O3kF","arrow":"index_arrow__Q+VQm"};